import PortfolioExperience from "./experiences/PortfolioExperience.js";

window.addEventListener("DOMContentLoaded", () => {
  const canvas = document.querySelector("canvas.webgl") as HTMLCanvasElement;

  const experience = new PortfolioExperience(canvas);

  // const experience = new ReelExperience(canvas);
});
